import { Box, withStyles } from "@mui/material";
import React from "react";
import styles from "./styles";
import logoBlanc from "../../../../ressources/images/logo_vertuloo_blanc.png";

const BlocDescription = () => (
  <Box className={"container"} sx={styles}>
    <img src={logoBlanc} width={392} alt="" />
    <p>
      la nouvelle <strong>plateforme digitale</strong> dédiée aux
      administrateurs de biens pour la{" "}
      <strong>
        sécurisation et le développement de leur activité de gestion locative
      </strong>
    </p>
  </Box>
);

export default BlocDescription;
